import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface ShipFromFilterChipProps {
  selectedShipFromWarehouse?: string
  shipFromWarehouseAreas?: PriceChangeFilterLookupItem[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const ShipFromFilterChip: React.FC<ShipFromFilterChipProps> = ({
  selectedShipFromWarehouse,
  onRemove,
  shipFromWarehouseAreas,
}) => {
  const shipFromWarehouseAreaLabel = useMemo(
    () =>
      shipFromWarehouseAreas?.find((shipFromWarehouseArea) => shipFromWarehouseArea.id === selectedShipFromWarehouse)
        ?.label ?? "",
    [selectedShipFromWarehouse, shipFromWarehouseAreas]
  )

  return (
    <FilterChip
      key='pricing.ship-from-filter-chip'
      data-testid='pricing.ship-from-filter-chip'
      label={`Ship From: ${shipFromWarehouseAreaLabel}`}
      onDelete={() => onRemove("shipFromId", undefined)}
    />
  )
}

export default ShipFromFilterChip
